import {Success} from "src/utils/action_utils";
import {SHOW_SNACK_BAR} from "src/control/actions/action_types";

export const showSnackBar = (message: string) => (dispatch: any) => {
    dispatch(Success(SHOW_SNACK_BAR, message))
}